import React from "react";
import NumberFormat from "react-number-format";

const mathSum = numbers => numbers.reduce((a, b) => a + b, 0);

const RankTable = ({rows}) => (
  <table style={{width: '100%'}}>
    <tbody>
      {rows && rows.length && rows.map((easy_pay_rank_item, easy_pay_rank_key) =>
        <tr style={{lineHeight: 1, fontSize: 14}}>
          <td style={{padding: '0 !important'}}>
            <div style={{float: 'left'}}>
              <span>{easy_pay_rank_key + 1}</span>&nbsp; &nbsp;
              <span>{easy_pay_rank_item.label}</span>&nbsp; &nbsp; &nbsp;
            </div>
            <div style={{borderBottom: '1px dashed black', overflow: 'hidden', marginTop: 10}} />
          </td>
          <td style={{padding: '0 !important', width: '1%', whiteSpace: 'nowrap', color: '#616161'}}>
            &nbsp;
            {!easy_pay_rank_item.amount && !easy_pay_rank_item.avg && 'N/A'}
            {!!easy_pay_rank_item.amount && !!easy_pay_rank_item.avg && <>
              <NumberFormat value={easy_pay_rank_item.amount} displayType="text" thousandSeparator prefix="$" />
              {' | Avg: '}
              <NumberFormat value={easy_pay_rank_item.avg} displayType="text" thousandSeparator prefix="$" />
            </>}
            {' | '}
            <span>{easy_pay_rank_item.cars}</span>
            {' Cars'}
          </td>
        </tr>
      )}

      <tr style={{lineHeight: 1, fontSize: 14}}>
        <td style={{padding: '0 !important'}}>
          <div style={{float: 'left'}}>
            &nbsp; &nbsp; &nbsp;<span>Total</span>&nbsp; &nbsp; &nbsp;
          </div>
          <div style={{borderBottom: '1px dashed black', overflow: 'hidden', marginTop: 10}} />
        </td>
        <td style={{padding: '0 !important', width: '1%', whiteSpace: 'nowrap', color: '#616161'}}>
          &nbsp;
          <>
            <NumberFormat value={mathSum(rows.map(row => row.amount))} displayType="text" thousandSeparator prefix="$" />
          </>
          {' | '}
          <span>{mathSum(rows.map(row => row.cars))}</span>
          {' Cars'}
        </td>
      </tr>

    </tbody>
  </table>
);

export default RankTable;
